import type { PropsWithChildren } from 'react';
import type React from 'react';

import { AmbassadorsPageStateContextProvider } from './pageState';

export const AmbassadorsPageContextProvider: React.FC<PropsWithChildren> = ({ children }) => {
	return <AmbassadorsPageStateContextProvider>{children}</AmbassadorsPageStateContextProvider>;
};
